import {
    makeExecutorUrl,
    trans,
} from '@frontend/helpers'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {ExecutorServices} from '@shared/components/Executors/ExecutorServices'
import {Link} from 'react-router-dom'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'

interface Props {
    executor: ExecutorPreviewData
    example?: boolean
}

// Содержимое карточки предпросмотра исполнителя в категории услуг.
export function ServicesListItemInfo(props: Props) {

    const {
        executor,
        example,
    } = props

    return (
        <div className="executor-card-info flex-xxl-1">
            <Link
                className="executor-card-title link-blue"
                target="_blank"
                to={makeExecutorUrl(executor.slugWithId, executor.categorySlugWithId)}
                rel="noreferrer"
                onClick={
                    example
                        ? event => event.preventDefault()
                        : undefined
                }
            >
                <img
                    // Для поисковиков.
                    src={executor.cover}
                    className="position-absolute opacity-0"
                    width={1}
                    height={1}
                    alt={executor.title}
                />
                {executor.name}: {executor.title}
            </Link>
            {executor.location && (
                <div className="mt-2 fs-7">
                    {executor.location}{executor.canWorkRemotely ? ' / ' + trans().services.details.remotely : ''}
                </div>
            )}
            <ExecutorServices
                services={executor.services}
                header={trans().services.details.services}
                priceLabel={trans().services.details.service_price}
                className="mt-2"
            />
            {executor.experience && (
                <div className="mt-2">
                    <div className="text-muted">
                        {trans().services.details.experience}:
                    </div>
                    <HtmlContent
                        block
                        html={executor.experience}
                        className="last-paragraph-no-margin"
                    />
                </div>
            )}
        </div>
    )
}
